import styled from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';
import { Typography } from '../../../ui/Typography';
import { FlexCenterAligned } from '../../../../styled/common';

export const SliderInfoContainer = styled.div`
  position: absolute;
  display: flex;
  bottom: 10px;
  padding: 0 20px;
  height: 25px;
  width: 100%;
  z-index: 3;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    bottom: 20px;
  }

  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 0 25px;
  }
`;

export const SliderInfoButtonsContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.background.primary};
  border-radius: 7px;

  svg {
    margin: 6px 5px;
  }
`;

export const SliderInfoCounter = styled(FlexCenterAligned)`
  position: absolute;
  left: 50%;
  height: 25px;
  transform: translateX(-50%);
  padding: 0 15px;
  border-radius: 7px;
  background-color: rgba(0, 0, 0, 0.4);
`;

export const CounterText = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.white};
`;
